export const ExposureCourseCostYearlyLimit = 2500;
export const EmploymentSupportCalendarYearLimit = 600;
export const DefaultEttsFundCalendarYearLimit = 542;
